export const anchorItems = [
  { key: "About me", href: "#about-me", title: "About me" },
  {
    key: "Interests-personality",
    href: "#interests-personality",
    title: "Interests & personality",
  },
  { key: "Contact", href: "#contact", title: "Contact" },
  { key: "Career", href: "#career", title: "Career" },
  { key: "Physical", href: "#physical", title: "Physical" },
  { key: "Family", href: "#family", title: "Family" },

  {
    key: "Partner-preferences",
    href: "#partner-preferences",
    title: "Partner preferences",
  },
];

export const partnerPreference = [
  {
    key: "age",
    label: "Age",
    minValue: "50",
    maxValue: "70",
    suffix: "yrs",
    type: "range",
  },
  { key: "religion", label: "Religion", value: "Muslim", type: "select" },
  {
    key: "qualification",
    label: "Qualification",
    value: "MBBS, MCA, Masters",
    type: "multiSelect",
  },
  {
    key: "occupation",
    label: "Profession",
    value: "Accountant, Doctor",
    type: "multiSelect",
  },
  {
    key: "annual_income",
    label: "Annual Income",
    type: "multiSelect",
  },
  { key: "diet", label: "Diet", value: "Non-veg", type: "multiSelect" },
  { key: "weight", label: "Weight", value: "56", type: "range" },
  {
    key: "marital_status",
    label: "Marital status",
    value: "Never married",
    type: "multiSelect",
  },
  {
    key: "family_type",
    label: "Family type",
    value: "Upper Middle Class",
    type: "multiSelect",
  },
  {
    key: "family_status",
    label: "Family Status",
    value: "Joint Family",
    type: "multiSelect",
  },
  {
    key: "complexion",
    label: "Complexion",
    value: "Light Brown, Fair",
    type: "multiSelect",
  },
  {
    key: "community",
    label: "Community",
    value: "Ezhava-Thiyya",
    type: "multiSelect",
  },
  {
    key: "height",
    label: "Height",
    value: "173",
    type: "range",
  },
  {
    key: "body_type",
    label: "Body type",
    value: "Slim, Average",
    type: "multiSelect",
  },
  { key: "drink", label: "Drinking", value: "No", type: "select" },
  { key: "smoke", label: "Smoking", value: "No", type: "select" },
  // { key: "city", label: "City", value: "kozhikode", type: "multiSelect" },
  {
    key: "country",
    label: "Nationality",
    value: "India, UAE",
    type: "multiSelect",
  },
  { key: "city", label: "State", value: "kallai", type: "multiSelect" },
  { key: "place", label: "District", value: "Kerala", type: "multiSelect" },
];

export const preferenceSelectOptions = {
  Religion: ["Hindu", "Muslim", "Christian"],
  Nationality: ["India", "UAE", "USA"],
  Qualification: ["MBBS", "MCA", "Masters"],
  Profession: ["Accountant", "Doctor", "Business"],
  Diet: ["Veg", "Non-veg"],
  "Marital status": ["Married", "Never married", "Widow"],
  "Family Status": ["Nuclear", "Joint Family", "Extended"],
  "Family type": [
    "Lower",
    "Middle Class",
    "Upper Middle Class",
    "Rich",
    "Affluent",
  ],
  Complexion: ["Light Brown", "Fair"],
  Community: ["Ezhava-Thiyya", "Nair", "Syrian Christian", "Latin Catholic"],
  "Body type": ["Slim", "Average"],
  Drinking: ["No", "Yes"],
  Smoking: ["No", "Yes"],
  Weight: Array.from({ length: 81 }, (_, i) => `${40 + i} kg`),
  Height: Array.from({ length: 71 }, (_, i) => `${140 + i} cm`),
};

export const VERIFICATION_TYPE = {
  ID_VERIFIED: 1,
  PHYSICAL_VERIFIED: 2,
  BOTH_VERIFIED: 3,
};
